import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from './token.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);

  const authReq = req.clone({
    setHeaders: {
      Authorization: 'Bearer ' + tokenService.getToken()
    }
  });

  return next(authReq);
};
